export default __webpack_public_path__ + "static/media/icon-ic-faceobook.d8f68ab7.svg";